import Link from 'next/link'
import React from 'react'
import { useMedia } from 'react-use'
import styled from 'styled-components'
import { phoneMaxWidth } from 'utils/media'
import { Avatar } from 'lib/Avatar'
import { usePopoverController } from 'lib/Popover'
import { useCurrentUser } from 'modules/auth/useCurrentUser'

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  position: relative;
`

const Anchor = styled.a`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
`

interface Props {
  controls: ReturnType<typeof usePopoverController>
}

export const CurrentUserAvatar = ({ controls }: Props) => {
  const { user } = useCurrentUser()

  const isPhoneDown = useMedia(`(max-width: ${phoneMaxWidth}px)`)

  if (!user) {
    return null
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    e.stopPropagation()
    controls.setOpen(!controls.open)
  }

  return (
    <Wrapper>
      <Link href={`/${user.username}`} passHref prefetch={false}>
        <Anchor aria-label="Current user avatar" onClick={handleClick}>
          <Avatar size={isPhoneDown ? 'tiny' : 'small'} user={user} />
        </Anchor>
      </Link>
    </Wrapper>
  )
}
